import React, { ReactChild, createContext } from 'react';
import useBudgetStatus from '../../lib/use-budget-status';
import { BudgetStatus, Env } from '../../types';

type BudgetStatusProviderProps = {
  token: string;
  environment: Env;
  children: ReactChild;
  onComplete?: () => void;
};

type TBudgetContext = {
  status: BudgetStatus;
  untrackedTransactions: number;
  forceUpdate?: () => void;
};

const BudgetContext = createContext<TBudgetContext>({
  status: BudgetStatus.Default,
  untrackedTransactions: 0,
});

function useForceUpdate() {
  const [value, setValue] = React.useState(0);
  return () => setValue(value + 1);
}

function BudgetStatusProvider({
  token,
  environment,
  children,
  onComplete,
}: BudgetStatusProviderProps) {
  const {
    data: { status, untrackedTransactions },
    error,
    loading,
  } = useBudgetStatus(token, environment, onComplete);

  const forceUpdate = useForceUpdate();

  if (loading) {
    return null;
  }

  if (error) {
    console.error(error);
    // TODO: log error to loggly
  }

  return (
    <BudgetContext.Provider
      value={{ status, untrackedTransactions, forceUpdate }}
    >
      {children}
    </BudgetContext.Provider>
  );
}

export default BudgetStatusProvider;
export { BudgetContext };
